<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='1'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">我的订单</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina" v-loading="qyloading">
            <!--右边内容区域开始-->
            <div class="cght_kbhei1"></div>
            <div class="cght_ddxqtop">
              <div class="cght_ddxqtop1">
                订单编号：{{orderDetail.order_id}}&emsp;&emsp;<!-- 状态：<em>paytype</em> -->&emsp;&emsp;<em v-if="totalPrice">订单总额：<span>￥{{ totalPrice.toFixed(2) }}</span></em>
              </div>
              <!-- <div class="cght_ddxqtop2">订单已经完成，感谢您的购物，欢迎您对本次交易及所购商品进行评价。</div> -->
            </div>
            <div class="cght_ddxqxxlm">
              <div class="cght_ddxqxxlm1">订单信息</div>
              <div class="cght_ddxqxxlm2">下单时间：{{orderDetail.create_time}}</div>
              <!-- <div class="cght_ddxqxxlm3">付款时间：</div> -->
              <!-- <div class="cght_ddxqxxlm4">发货时间：</div> -->
            </div>
            <ul class="cght_ddxqxxlmmain">
              <li>
                <!-- <div class="cght_ddxqxxlmmainti">收货人信息</div> -->
                <div class="cght_ddxqxxlmmainwr">
                  收&ensp;货&ensp;人：{{orderDetail.address_name}}<br/>
                  地&emsp;&emsp;址：{{orderDetail.province}}-{{orderDetail.city}}-{{orderDetail.district}}-{{orderDetail.address_detail}}<br/>
                  手机号码：{{orderDetail.tel}}<br/>
                  备注：{{orderDetail.remark}}
                </div>
              </li>
              <!-- <li>
                <div class="cght_ddxqxxlmmainti">支付明细</div>
                <div class="cght_ddxqxxlmmainwr">
                  支付方式：{$order.paytype}<br />
                  总商品金额：￥{$order.goodsamount}<br />
                  运&emsp;&emsp;费：￥{$order.shippingfee}<br />
                  应付总额：￥{$order.orderamount}
                </div>
              </li> -->
              <!-- <li>
                <div class="cght_ddxqxxlmmainti">发票信息</div>
                <div class="cght_ddxqxxlmmainwr">发票类型：普通发票<br />发票抬头：个人<br />发票内容：明细</div>
              </li> -->
            </ul>
            <div class="cght_ddxqbot">
              <div class="cght_ddxqbotti">商品清单
                <!-- <em style="float: right">拒绝原因：XXXXXXX</em> -->
              </div>
              <ul class="cght_ddxqbotult">
                <li class="cght_ddxqbot1">商品图片</li>
                <li class="cght_ddxqbot2">商品名称</li>
                <li class="cght_ddxqbot3">金额</li>
                <li class="cght_ddxqbot4">数量</li>
                <li class="cght_ddxqbot5">小计</li>
                <li class="cght_ddxqbot6">状态</li>
              </ul>
              <ul class="cght_ddxqbotulma" v-for="(item,index) in orderDetail.orderdetail" :key="index">
                <li class="cght_ddxqbot1">
                  <router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">
                    <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" width="60" height="60" :alt="item.title" />
                  </router-link>
                </li>
                <li class="cght_ddxqbot2">
                  <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">{{item.title}}</router-link></h3>
                  <div>
                    <el-tag size="mini" style="margin-left:3px" v-for="(ie,i) in item.specParamList" :key="i">{{ie.param_name}}：{{ie.option_value}}</el-tag>
                  </div>
                  <div>
                    <div v-for="(ie,i) in item.leaveMessage" :key="i">
                      <el-tag size="mini" effect="plain" style="margin-left:3px">{{ie.name}}：{{ie.value}}</el-tag>
                    </div>
                  </div>
                </li>
                <li class="cght_ddxqbot3" v-if="item.price_show === 0 && item.tax_price && item.tax_price > 0">￥{{item.tax_price}}</li>
                <li class="cght_ddxqbot3" v-else>询价</li>
                <li class="cght_ddxqbot4">{{item.number}}</li>
                <li class="cght_ddxqbot5" v-if="item.price_show === 0 && (item.tax_price * item.number) && (item.tax_price * item.number) > 0">￥{{(item.tax_price * item.number).toFixed(2)}}</li>
                <li class="cght_ddxqbot5" v-else>询价</li>
                <li class="cght_ddxqbot6">
                  <div style="width:100%;display:block;line-height:36px;" v-if="item.state==0">未发货</div>
                  <div style="width:100%;display:block;line-height:36px;color:#436aa6;cursor:pointer;">
                    <el-button v-if="item.state==1" size="mini" type="primary" plain @click="takedeliveryofgoods(item)">确认收货</el-button>
                  </div>
                  <div style="width:100%;display:block;line-height:36px;color:#436aa6;cursor:pointer;" v-if="item.state==1" @click="checkLogistics(item)">查看物流</div>
                  <div style="width:100%;display:block;line-height:36px;" v-if="item.state==2">已收货</div>
                </li>
              </ul>
              <div class="cght_ddxqbotqsxx">
                <div class="cght_ddxqbotqsxxr" v-if="totalPrice"><em>商品总金额：</em>￥{{ totalPrice.toFixed(2) }}</div>
                <!-- <div class="cght_ddxqbotqsxxr cght_ddxqbotqsxxrpb"><em>+运费：</em>￥{$order.shippingfee}</div> -->
                <div class="cght_ddxqbotqsxxv" v-if="totalPrice"><div>应付总额：<em>￥{{ totalPrice.toFixed(2) || '--' }}</em></div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Logistics v-if="dialogFormVisible" :dialogFormVisible="dialogFormVisible" @changeParents="changeParents" :parents-list="parentsList"></Logistics>
    </div>
    <Bottom/>
  </div>
</template>
<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import api from '@/api/order'
import Logistics from '@/components/Logistics'

export default {
  name: 'OrderDetail',
  components: { Top, LeftNav, Bottom, Logistics },
  data () {
    return {
      dialogFormVisible: false,
      qyloading: false,
      order_id: this.$route.query.order_id,
      orderDetail: [],
      parentsList: {},
      totalPrice: 0.00
    }
  },
  mounted () {
    this.Get()
  },
  methods: {
    Get () {
      this.qyloading = true
      api.Get({id: this.order_id}).then(res => {
        if (!res.data) {
          this.$router.push({path: '/MyOrder'})
          return
        }
        this.orderDetail = res.data
        this.orderDetail.orderdetail.map(response => {
          if (response.specParamList) {
            response.specParamList = JSON.parse(response.specParamList)
          }
          if (response.leaveMessage) {
            response.leaveMessage = JSON.parse(response.leaveMessage)
          }
          if (response.price_show !== 1) {
            this.totalPrice += response.number * response.tax_price
          }
        })
        this.qyloading = false
      })
    },
    checkLogistics (item) {
      // var data = {
      //   id: 'a2a1c1523f61ee66a06083aa2c5f41c7',
      //   com: item.expressagebh,
      //   nu: item.express_number,
      //   show: 0,
      //   muti: 0,
      //   order: 'desc'
      // }
      // api.checkLogistics(data).then(res => {
      //   console.info(res)
      // })
      item.tel = this.orderDetail.tel
      this.parentsList = Object.assign({}, item)
      this.dialogFormVisible = true
    },
    changeParents (state) {
      this.dialogFormVisible = state
    },
    // 确认收货
    takedeliveryofgoods (goods) {
      this.$confirm('确认收到货了吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.takedeliveryofgoods({ detailID: goods.id }).then(res => {
          goods.state = 2
          this.$message({
            type: 'success',
            message: '确认收货!'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
  .cght_ddxqtop1{
    border: none;
  }
  .cght_ddxqbotulma li{
    height: auto;
  }
  .cght_ddxqbotulma{
    display: flex;
    vertical-align: middle;
  }
  .cght_ddxqbotulma .cght_ddxqbot2{
    padding: 11px 11px;
    width: 420px;
  }
  .cght_ddxqbot1{
    width: 120px;
  }
  .cght_ddxqbot2{
    width: 442px;
  }
  .cght_ddxqbotult .cght_ddxqbot3{
    width: 100px;
  }
  .cght_ddxqbotult .cght_ddxqbot5{
    width: 100px;
  }
  .cght_ddxqbotulma .cght_ddxqbot3{
    width: 100px;
  }
  .cght_ddxqbotulma .cght_ddxqbot5{
    width: 100px;
    color: #dd2d3a;
    font-weight: 600;
  }
  .cght_ddxqbot4{
    width: 80px;
  }
  .cght_ddxqbotult .cght_ddxqbot6{
    width: 118px;
  }
  .cght_ddxqbotulma .cght_ddxqbot6{
    width: 118px;
    text-align: center;
    line-height: 78px;
    border-left: 1px solid #efefef;
    border-right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/order_detail.vue